import {
  ConsultaSeguimentoPergunta20ExemplosEnum,
  ConsultaSeguimentoPergunta20Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-20/model-consultaSeguimentoPergunta20'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta20Model {
  header: MchatRfAplicacaoQueryModel
  subItemComplementar: MchatRfAplicacaoQueryModel | undefined
  perguntas: MchatRfAplicacaoQueryModel[]
  model: ConsultaSeguimentoPergunta20Model
}

export const convertAplicacaoPergunta20 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta20Model | null => {
  const { header, perguntas: resto } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_20_01)

  if (isUndefinedOrNull(header)) return null

  const subItemComplementar = resto.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_20_02)
  const perguntas = resto.filter((aplicacao) => PERGUNTA_20_PERGUNTAS.includes(aplicacao.pergunta))

  return {
    header,
    subItemComplementar,
    perguntas,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_20_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR: booleanToSimNaoEnum(subItemComplementar?.stPassou),
      PERGUNTA_20_EXEMPLOS: convertAplicacoesToExemplos(perguntas),
      PERGUNTA_20_OUTRO: convertAplicacaoToOutro(
        perguntas.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_20_06)
      ),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta20ExemplosEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta20ExemplosEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const convertAplicacaoToOutro = (
  aplicacao: MchatRfAplicacaoQueryModel | undefined
): ConsultaSeguimentoPergunta20Model['PERGUNTA_20_OUTRO'] => ({
  radioValue: booleanToSimNaoEnum(aplicacao?.stPassou),
  textValue: aplicacao?.outros ?? undefined,
})

const PERGUNTA_20_PERGUNTAS = [
  MChatPerguntaEnum.PERGUNTA_20_03,
  MChatPerguntaEnum.PERGUNTA_20_04,
  MChatPerguntaEnum.PERGUNTA_20_05,
  MChatPerguntaEnum.PERGUNTA_20_06,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta20ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta20ExemplosEnum.RI_OU_GARGALHA]: undefined,
  [ConsultaSeguimentoPergunta20ExemplosEnum.FALA_OU_EMITE_SOM]: undefined,
  [ConsultaSeguimentoPergunta20ExemplosEnum.PEDE_MAIS]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta20ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_20_03]: ConsultaSeguimentoPergunta20ExemplosEnum.RI_OU_GARGALHA,
  [MChatPerguntaEnum.PERGUNTA_20_04]: ConsultaSeguimentoPergunta20ExemplosEnum.FALA_OU_EMITE_SOM,
  [MChatPerguntaEnum.PERGUNTA_20_05]: ConsultaSeguimentoPergunta20ExemplosEnum.PEDE_MAIS,
}
